var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80064 0.0666777C6.22065 0.0666777 5.64003 0.287607 5.19803 0.73074L0.6647 5.26407C-0.221567 6.15034 -0.221567 7.58528 0.6647 8.46928L17.1954 25L0.6647 41.5307C-0.221567 42.417 -0.221567 43.8519 0.6647 44.7359L5.19803 49.2693C6.0843 50.1555 7.51924 50.1555 8.40324 49.2693L24.934 32.7386L41.4647 49.2693C42.3487 50.1555 43.7859 50.1555 44.6699 49.2693L49.2032 44.7359C50.0895 43.8497 50.0895 42.4147 49.2032 41.5307L32.6725 25L49.2032 8.46928C50.0895 7.58528 50.0895 6.14807 49.2032 5.26407L44.6699 0.73074C43.7836 -0.155527 42.3487 -0.155527 41.4647 0.73074L24.934 17.2615L8.40324 0.73074C7.96011 0.287607 7.38062 0.0666777 6.80064 0.0666777Z",
    fill: "#E8D880"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.22b60998.svg";
export { ForwardRef as ReactComponent };